import React, { Component, PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import firebase from '@firebase/app'
import '@firebase/storage'
import moment from 'moment'
import slugify from 'slugify'
import { trackPromise } from 'react-promise-tracker'
import _ from 'lodash'

import cookie from 'react-cookies'

import { obtainFolderVideos } from '../../Api/base'
import {
  getAllUserWatchedVideos,
  getAllUserWatchedVideosByFolder,
  getAllUserStatusesForPaidContent,
} from '../../Api/videoApi'
import {
  getTrainingDays,
  getStripePaidContent,
  getUserCurrentStage,
} from '../../Api/backendApi'
import * as videosActions from '../../actions/videosActions'
import * as folderActions from '../../actions/folderActions'
import MobileFolderScreen from './MobileFolderScreen'
import Cookies from 'universal-cookie'
import AppContext from '../../context/appContext'

class MobileFolderScreenContainer extends PureComponent {
  static contextType = AppContext
  state = {
    folderName: this.props.match.params.folderName.toLowerCase(),
    isLoading: false,
    folderPath: this.props.location.state.path,
    videos: [],
    albumId: this.props.location.state.albumId,
    userWatchedVideosFromThisFolder: [],
    userAllWatchedVideos: [],
    allUserWatchedVideos: [],
    lockedVideo: null,
    watchedVideo: null,
    isLockedVideoToday: false,
    isTodayWatchedVideo: false,
    todayWatchedVideo: null,
    todayLockedVideo: null,
    folderName: '',
    keywords: this.props.location.state.keywords,
    pdfItems: [],
    pdfUrls: [],
    isLockTimerSet: false,
    isMiazgaEntryVideoWatched: false,
    shouldRenderDialog: false,
    isThisPaidContentFolder: false,
    nextTrainingToWatchOrder: null,
    userHasLockedVideo: false,
    isAfterTrainingPopupOpen: false,
    isAfterCompleteMiazgaPopupOpen: false,
    isNotCompletedLockedTrainingPopupOpen: true,
  }

  componentDidMount = async () => {
    this.unlisten = this.props.history.listen((location, action) => {
      if (action == 'POP') {
        window.location.reload()
      }
    })
    await this.getPdfName()
    ;(await this.state.pdfName) !== null &&
      this.obtainFirebase(this.state.pdfName)
    await this.getPaidContent()
    await this.splitFolderName()
    await this.getUserTrainingDays()
    await this.isTodayTrainingDay()
    await this.checkNextTrainingDay()
    await this.manageVideos()
    await this.getTodaysTraining()
    await this.updateStateVideos()
    await this.checkLastBlockedVideo()
    await this.checkIfUserHasLockedVideo()
    await this.checkIfTodayIsLockedVideo()
    // await this.isTodayBetweenLockAndTraining()
    await this.checkIfTodayIsWatchedVideo()
    await this.makeAvaiblevideos()
    await this.sortPdfs()
    await this.checkFolderEmail()
    await this.checkIfIntroIsWatched()
    await this.shouldRenderDialog()
    await this.showAfterCompletedTrainingPopup()
    // await this.addRoomsToFirebase()
  }

  // addRoomsToFirebase = async () => {
  //   // userJoinToMeeting(roomKey)
  //   let counter = 2415
  //   if (this.state.videos) {
  //     this.state.videos.forEach((video) => {
  //       for (let i = 0; i < 5; i++) {
  //         counter++
  //         console.log(counter)
  //         console.log(parseInt(this.state.albumId) - 6)
  //         firebase
  //           .database()
  //           .ref(`/rooms/${counter}/`)
  //           .set({
  //             is_locked: false,
  //             key: counter,
  //             miazga_id: parseInt(this.state.albumId) - 6,
  //             session_id: 1,
  //             video_id: video.order,
  //           })
  //       }
  //     })
  //   }
  // }

  isToday = (someDate) => {
    const today = new Date()
    const inputDate = new Date(someDate)

    return (
      inputDate.getDate() == today.getDate() &&
      inputDate.getMonth() == today.getMonth() &&
      inputDate.getFullYear() == today.getFullYear()
    )
  }

  showAfterCompletedTrainingPopup = () => {
    if (
      (this.state.folderName && this.state.folderName.includes('MIAZGA')) ||
      this.state.isThisPaidContentFolder
    ) {
      if (cookie.load('userCompletedTraining')) {
        cookie.remove('userCompletedTraining', { path: '/' })
        this.toggleAfterTrainingPopupOpen()
      }
    }
  }

  toggleAfterTrainingPopupOpen = async () => {
    this.setState({
      isAfterTrainingPopupOpen: !this.state.isAfterTrainingPopupOpen,
    })

    setTimeout(async () => {
      if (!this.state.isAfterTrainingPopupOpen) {
        let userCurrentStage = await getUserCurrentStage()

        this.setState({
          userCurrentStage: userCurrentStage,
        })

        if (userCurrentStage && userCurrentStage.is_stage_completed == true) {
          this.toggleAfterCompleteMiazgaPopupOpen()
        }
      }
    }, 200)
  }

  toggleAfterCompleteMiazgaPopupOpen = () => {
    this.setState({
      isAfterCompleteMiazgaPopupOpen:
        !this.state.isAfterCompleteMiazgaPopupOpen,
    })
  }

  getPaidContent = async () => {
    let content

    if (this.context && !this.context.appState.paidContent) {
      content = await getStripePaidContent()
      this.context.updateAppState('paidContent', content)
    } else {
      content = this.context.appState.paidContent
    }

    this.setState({
      paidContent: content,
    })
  }

  renderCorrectDayName = (dayNumber) => {
    let dayName
    switch (dayNumber) {
      case 1:
        dayName = 'Poniedziałek'
        return dayName
      case 2:
        dayName = 'Wtorek'
        return dayName
      case 3:
        dayName = 'Środa'
        return dayName
      case 4:
        dayName = 'Czwartek'
        return dayName
      case 5:
        dayName = 'Piątek'
        return dayName
      case 6:
        dayName = 'Sobota'
        return dayName
      case 7:
        dayName = 'Niedziela'
        return dayName
      default:
        break
    }
  }

  renderNextTrainingBadge = () => {
    const { closestTrainingDay, closestTrainingDate } = this.state
    const shortTrainingDate =
      closestTrainingDate && closestTrainingDate.split('-')
    const dayName = this.renderCorrectDayName(closestTrainingDay)
    if (closestTrainingDay && closestTrainingDate) {
      return `Dostępny: ${dayName} - ${
        shortTrainingDate && shortTrainingDate[0]
      }.${shortTrainingDate && shortTrainingDate[1]}`
    }
  }

  showUnlockTime = (video, i) => {
    let shouldTimerBeShown = false
    const {
      videos,
      isTodayTrainingDay,
      isLockedVideoToday,
      isTodayWatchedVideo,
    } = this.state

    if (videos) {
      if (i == 0 && !video.is_watched) {
        shouldTimerBeShown = false
        return shouldTimerBeShown
      } else if (i >= 1) {
        if (
          i >= 1 &&
          (video.is_watched == undefined || !video.is_watched) &&
          videos[i - 1].is_watched &&
          (!this.state.isTodayTrainingDay || isTodayWatchedVideo)
        ) {
          shouldTimerBeShown = true
          return shouldTimerBeShown
        }
      }
    }
    return shouldTimerBeShown
  }

  getPdfName = () => {
    let fullName
    let slicedName
    let lowerName
    this.state.keywords.forEach((keyword) => {
      if (keyword.text.includes('PDF_FILE_')) {
        fullName = keyword.text
        return
      }
    })
    if (fullName !== undefined) {
      slicedName = fullName.split('_')
      lowerName = slicedName[2].toLowerCase()
      this.setState({
        pdfName: lowerName,
      })
    } else {
      this.setState({
        pdfName: null,
      })
    }
  }

  unlockAlgorithm = (video, i) => {
    const videos = this.state.videos
    const videoId = video.uri.split('/')
    let shouldbeUnclocked = false
    const date = new Date()
    const albumName = this.state.folderName
    const isLockedVideoToday = this.state.isLockedVideoToday
    const todayLockedVideo = this.state.todayLockedVideo
    const isTodayTrainingDay = this.state.isTodayTrainingDay
    const isTodayWatchedVideo = this.state.isTodayWatchedVideo
    const todayWatchedVideo = this.state.todayWatchedVideo
    let isThisPaidContentFolder = false
    let userHas

    this.state.paidContent &&
      this.state.paidContent.forEach((content) => {
        if (content.name == albumName) {
          isThisPaidContentFolder = true

          this.setState({
            isThisPaidContentFolder: true,
          })
          return isThisPaidContentFolder
        }
      })

    // first of all check if this is miazga folder
    if (albumName.includes('MIAZGA')) {
      // first video - intro allways unlocked
      if (i == 0) {
        shouldbeUnclocked = true
        return shouldbeUnclocked
      }

      if (i >= 1) {
        if (video.is_watched) {
          shouldbeUnclocked = true
          return shouldbeUnclocked
        }

        if (isLockedVideoToday) {
          if (todayLockedVideo.video_id == videoId[2]) {
            shouldbeUnclocked = true
            return shouldbeUnclocked
          }
          shouldbeUnclocked = false
          return shouldbeUnclocked
        }

        if (isTodayWatchedVideo) {
          if (todayWatchedVideo.video_id == videoId[2]) {
            shouldbeUnclocked = true
            return shouldbeUnclocked
          }
          shouldbeUnclocked = false
          return shouldbeUnclocked
        }

        if (isTodayTrainingDay) {
          if (videos[i - 1].is_watched) {
            shouldbeUnclocked = true
            return shouldbeUnclocked
          }
        }
      }
    } else if (isThisPaidContentFolder) {
      // Algorythm for paid content eg "szpagaty"
      shouldbeUnclocked = this.shouldPaidPackageVideoBeUnlocked(i)
      return shouldbeUnclocked
    } else {
      shouldbeUnclocked = true
      return shouldbeUnclocked
    }
    return shouldbeUnclocked
  }

  shouldPaidPackageVideoBeUnlocked = (videoNumber) => {
    const { userWatchedVideosFromThisFolder } = this.state
    let paidUnlock = false
    let prevVideo
    const date = new Date()
    const today = moment(date).format('YYYY-MM-DD')

    // first video is always unlocked
    if (videoNumber == 0) {
      paidUnlock = true
      return paidUnlock
    }
    // second video - dont check prev vid date when unlocking
    if (videoNumber == 1) {
      if (userWatchedVideosFromThisFolder) {
        let currentVideo = userWatchedVideosFromThisFolder.filter(
          (watchedVid) => watchedVid.video_order_id == videoNumber
        )
        prevVideo = userWatchedVideosFromThisFolder.filter(
          (watchedVid) => watchedVid.video_order_id == videoNumber - 1
        )

        if (prevVideo && prevVideo.length) {
          if (
            userWatchedVideosFromThisFolder[videoNumber] &&
            userWatchedVideosFromThisFolder[videoNumber].is_watched
          ) {
            paidUnlock = true
            return paidUnlock
          } else if (prevVideo[0].is_watched) {
            paidUnlock = true
            return paidUnlock
          } else {
            paidUnlock = false
            return paidUnlock
          }
        }
      }
    }
    // Every other video than first and second
    else if (userWatchedVideosFromThisFolder) {
      prevVideo = userWatchedVideosFromThisFolder.filter(
        (watchedVid) => watchedVid.video_order_id == videoNumber - 1
      )

      let currentVideo = userWatchedVideosFromThisFolder.filter(
        (watchedVid) => watchedVid.video_order_id == videoNumber
      )

      if (prevVideo && prevVideo.length) {
        if (
          userWatchedVideosFromThisFolder[videoNumber] &&
          userWatchedVideosFromThisFolder[videoNumber].is_watched
        ) {
          paidUnlock = true
          return paidUnlock
        } else if (
          moment(prevVideo[0].watched_datetime).format('YYYY-MM-DD') != today &&
          prevVideo[0].is_watched
        ) {
          paidUnlock = true
          return paidUnlock
        } else {
          paidUnlock = false
          return paidUnlock
        }
      }
    }

    return paidUnlock
  }

  checkIfTodayIsWatchedVideo = () => {
    const statuses = this.state.allUserWatchedVideos
    const date = new Date()
    const today = moment(date).format('YYYY-MM-DD')

    if (statuses)
      statuses.forEach((status) => {
        if (
          moment(status.watched_datetime).format('YYYY-MM-DD') == today &&
          status.album.title &&
          status.album.title.includes('miazga') &&
          !status.is_intro
        ) {
          this.setState({
            isTodayWatchedVideo: true,
            todayWatchedVideo: status,
          })
        }
      })
  }

  obtainFirebase = (name) => {
    const storage = firebase.storage()

    const storageRef = storage.ref()
    var imagesRef = storageRef.child(name)

    imagesRef
      .listAll()
      .then((res) => {
        res.items.forEach((item) => {
          this.setState({
            pdfItems: [...this.state.pdfItems, item.name],
          })
          createDownloadableLink(item)
        })
      })
      .catch((e) => {})

    const createDownloadableLink = (item) => {
      var downloadPDF = storageRef.child(item.location.path)
      let itemUrl
      downloadPDF
        .getDownloadURL()
        .then((url) => {
          let slicedName
          let onlyName

          if (item.name.includes('_')) {
            itemUrl = url
            slicedName = item.name.split('_')
            onlyName = slicedName[1].slice(0, -4)
          } else {
            itemUrl = url
            slicedName = item.name.split('-')
            onlyName = slicedName[1].slice(0, -4)
          }

          this.setState({
            pdfUrls: [
              ...this.state.pdfUrls,
              { url: url, name: onlyName, order: parseInt(slicedName[0]) },
            ],
          })
          return itemUrl
        })

        .catch(function (error) {
          switch (error.code) {
            case 'storage/object-not-found':
              // File doesn't exist
              break

            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break

            case 'storage/canceled':
              // User canceled the upload
              break

            case 'storage/unknown':
              // Unknown error occurred, inspect the server response
              break
          }
        })
    }
  }

  getTodaysTraining = () => {
    const { userWatchedVideosFromThisFolder } = this.state
    let lastWatchedVideo

    // 1. pull the last watched (with is_watched flag on true) from userWatchedVideosFromThisFolder collection state

    if (
      ((this.state.folderName && this.state.folderName.includes('MIAZGA')) ||
        this.state.isThisPaidContentFolder) &&
      userWatchedVideosFromThisFolder &&
      userWatchedVideosFromThisFolder.length > 0
    ) {
      let lastWatchedVideo =
        userWatchedVideosFromThisFolder.length > 0 &&
        userWatchedVideosFromThisFolder.reduce((prev, current) =>
          prev.video_order_id > current.video_order_id
            ? prev
            : current.is_watched
            ? current
            : prev
        )

      this.setState({
        lastWatchedVideoFromThisFolder: lastWatchedVideo,
        nextTrainingToWatchOrder: lastWatchedVideo.is_watched
          ? lastWatchedVideo.video_order_id + 1
          : lastWatchedVideo.video_order_id,
      })
    } else {
      this.setState({
        lastWatchedVideoFromThisFolder: null,
        nextTrainingToWatchOrder: 0,
      })
    }
    // 2. Store this video in state in order to use it later in next training functionality
  }

  sortPdfs = () => {
    const pdfs = this.state.pdfUrls

    const sorted = _.sortBy(pdfs, 'order')
  }

  manageVideos = async () => {
    const { folderPath, keywords } = this.state
    // const { folderWatchedVideos, allWatchedVideos } = this.props.folders
    let albumCorrectId = null
    let extractedAlbumId = null
    let allAlbumVids
    let watchedVids
    let allWatchedVids

    const isThisPaidContent =
      this.state.paidContent &&
      this.state.paidContent.filter(
        (content) => content.name == this.state.folderName
      )

    const endpointUrl = this.state.folderName.includes('iazga')
      ? 'videostatus'
      : 'videostatuschallange'

    albumCorrectId =
      keywords && keywords.filter((keyword) => keyword.text.includes('ALBUM_'))

    extractedAlbumId =
      albumCorrectId.length && albumCorrectId[0].text.split('_')

    this.setState({
      albumId: extractedAlbumId && extractedAlbumId[1],
    })

    const ifAppStateFolder = (folderName) => {
      let isFolderExists = false
      if (
        this.context.appState.folderView !== undefined &&
        this.context.appState.folderView.length
      ) {
        const appStateFolder = this.context.appState.folderView.filter(
          (folder) => folder.folderName === this.state.folderName
        )
        appStateFolder.length
          ? (isFolderExists = true)
          : (isFolderExists = false)
      }

      return isFolderExists
    }

    const getAppStateFolder = () => {
      let appStateFolder
      if (this.context.appState.folderView !== undefined) {
        appStateFolder = this.context.appState.folderView.filter(
          (folder) => folder.folderName === this.state.folderName
        )
      }
      return appStateFolder
    }

    if (this.context.appState.folderView) {
      // getAppStateFolder(this.state.folderName))
    }

    if (!ifAppStateFolder()) {
      allAlbumVids = await trackPromise(obtainFolderVideos(folderPath))

      watchedVids = await trackPromise(
        getAllUserWatchedVideosByFolder(
          extractedAlbumId && extractedAlbumId[1],
          isThisPaidContent.length
        )
      )

      allWatchedVids = await trackPromise(
        getAllUserWatchedVideos(isThisPaidContent.length)
      )
    } else {
      allAlbumVids = getAppStateFolder()[0].videos
      watchedVids = getAppStateFolder()[0].userWatchedVideosFromThisFolder
      allWatchedVids = getAppStateFolder()[0].allUserWatchedVideos
    }

    // if (allWatchedVids && watchedVids) {
    //   await this.props.folderActions.fetchUserAllWatchedVideos(allWatchedVids)
    //   await this.props.folderActions.fetchUserFolderWatchedVideos(watchedVids)
    // }
    let sorted = []
    let unchangedFolders = allAlbumVids
    let unsorted = allAlbumVids
    let onlyNumber

    if (unsorted !== undefined) {
      unsorted.map((video) => {
        video.tags.forEach((tag) => {
          if (tag.tag.includes('VIDEO_ORDER')) {
            unchangedFolders.map((stateFolder) => {
              if (stateFolder.uri === video.uri) {
                onlyNumber = tag.tag.replace(/VIDEO_ORDER_/g, '')
                stateFolder.order = parseInt(onlyNumber)
              }
            })
          } else if (tag.tag.includes('POWITANIE')) {
            unchangedFolders.map((stateFolder) => {
              if (stateFolder.uri === video.uri) {
                stateFolder.order = -1
              }
            })
          }
        })
      })
      sorted = unchangedFolders.sort(function (a, b) {
        return a.order - b.order
      })

      await this.setState({
        videos: sorted,
        userWatchedVideosFromThisFolder: watchedVids,
        allUserWatchedVideos: allWatchedVids,
      })

      //! THERE ARE NO FOLDER APP STATE YET

      if (!this.context.appState.folderView) {
        this.context.updateAppState('folderView', [
          {
            folderId: extractedAlbumId && extractedAlbumId[1],
            videos: sorted,
            userWatchedVideosFromThisFolder: watchedVids,
            allUserWatchedVideos: allWatchedVids,
            folderName: this.state.folderName,
          },
        ])
      } else {
        let isThisFolderInState = false
        this.context.appState.folderView.forEach((folder) => {
          if (folder.folderName == this.state.folderName) {
            isThisFolderInState = true
          }
        })

        if (!isThisFolderInState) {
          this.context.updateAppState('folderView', [
            ...this.context.appState.folderView,
            {
              folderId: extractedAlbumId && extractedAlbumId[1],
              videos: sorted,
              userWatchedVideosFromThisFolder: watchedVids,
              allUserWatchedVideos: allWatchedVids,
              folderName: this.state.folderName,
            },
          ])
        } else {
          return
        }
      }
    }
  }

  isWatchedAndLocked = (video) => video.is_watched && video.is_locked

  updateStateVideos = async () => {
    const folderWatchedVids = this.props.folders.folderWatchedVideos

    if (folderWatchedVids) {
      folderWatchedVids.forEach((vid) => {
        if (vid.is_watched) {
          this.setState((prevState) => ({
            videos: prevState.videos.map((video) =>
              video.uri.split('/')[2] == vid.video_id
                ? { ...video, is_watched: true }
                : video
            ),
          }))
        }
        if (vid.is_locked) {
          this.setState((prevState) => ({
            videos: prevState.videos.map((video) =>
              video.uri.split('/')[2] == vid.video_id
                ? { ...video, is_locked: true }
                : video
            ),
          }))
        }
      })
    }
  }

  makeAvaiblevideos = () => {
    const videos = this.state.videos

    let available = videos.map((video, i) => {
      if (this.unlockAlgorithm(video, i)) {
        return {
          ...video,
          isAvailable: true,
        }
      } else {
        return {
          ...video,
          isAvailable: false,
        }
      }
    })

    this.setState({
      videos: available,
    })
  }

  checkIfItsFirstVideo = (i, video) => i == 0

  checkIfThisIsLockedVid = (video) => {
    const videoId = video.uri.split('/')
    if (this.state.todayLockedVideo) {
      if (videoId[2] == this.state.todayLockedVideo.video_id) {
        return true
      }
    }
    return false
  }

  checkIfPrevVidIswatched = (i, video) => {
    if (i > 0 && this.state.videos[i - 1].is_watched !== undefined) {
      if (
        i > 0 &&
        this.state.videos[i - 1].is_watched !== undefined &&
        this.state.videos[i].is_watched == undefined &&
        this.state.isLockedVideoToday
      ) {
        return false
      }
      return true
    } else {
      return false
    }
  }

  isTodayTrainingDay = () => {
    if (
      this.state.userTrainingDays &&
      this.state.userTrainingDays.includes(this.state.todayDay)
    ) {
      this.setState({
        isTodayTrainingDay: true,
      })
    } else {
      this.setState({
        isTodayTrainingDay: false,
      })
    }
  }

  checkNextTrainingDay = async () => {
    const dateDay = new Date()

    let day = moment(dateDay).isoWeekday()

    const trainingDays = this.state.userTrainingDays

    function getNextHighestNumber(arr, number) {
      let fixedNum
      if (arr) {
        for (let i = 0; i < arr.length; i++) {
          if (
            number == 7 ||
            (number == 6 && !arr.includes(7)) ||
            (number == 5 && !arr.includes(6) && number == 5 && !arr.includes(7))
          ) {
            fixedNum = 0
          } else {
            fixedNum = number
          }
          if (arr[i] > fixedNum) {
            return arr[i]
          }
        }
      }
      return number
    }

    let sorted = trainingDays && trainingDays.sort()

    const calculateTrainingDate = () => {
      let trainingDate
      if (sorted) {
        if (
          day == 5 &&
          !sorted.includes(7) &&
          day == 5 &&
          !sorted.includes(6)
        ) {
          trainingDate = dateDay.setDate(
            dateDay.getDate() + (2 + getNextHighestNumber(sorted, day))
          )
          return trainingDate
        } else if (day == 6 && !sorted.includes(7)) {
          trainingDate = dateDay.setDate(
            dateDay.getDate() + (1 + getNextHighestNumber(sorted, day))
          )
          return trainingDate
        } else if (day == 7) {
          trainingDate = dateDay.setDate(
            dateDay.getDate() + getNextHighestNumber(sorted, day)
          )
          return trainingDate
        } else {
          trainingDate = dateDay.setDate(
            dateDay.getDate() + (getNextHighestNumber(sorted, day) - day)
          )
          return trainingDate
        }
      }
    }

    this.setState({
      closestTrainingDay: getNextHighestNumber(sorted, day),
      todayDay: day,
      closestTrainingDate: moment(calculateTrainingDate()).format('DD-MM-YYYY'),
    })

    return getNextHighestNumber(sorted, day)
  }

  checkUserWatchedVideos = (userWatchedVideosFromThisFolder, value, i) => {
    if (userWatchedVideosFromThisFolder) {
      var result = userWatchedVideosFromThisFolder.find((vid) => {
        return vid.video_order_id === i
      })

      result
        ? result.is_watched
          ? (value = false)
          : (value = true)
        : (value = true)
    }
    return value
  }

  checkIfUserHasLockedVideo = () => {
    if (this.state.allUserWatchedVideos) {
      this.state.allUserWatchedVideos.filter((video) =>
        !video.is_watched && video.is_locked
          ? this.setState({
              userHasLockedVideo: video,
            })
          : null
      )
    }
  }

  checkLastBlockedVideo = async () => {
    const allWatchedVids = this.state.allUserWatchedVideos
    let maxDate
    const date = new Date()

    if (allWatchedVids !== undefined && allWatchedVids.length > 0) {
      maxDate = allWatchedVids.reduce(function (prev, curr) {
        return prev.locked_datetime > curr.locked_datetime ? prev : curr
      })
    }

    if (maxDate != undefined) {
      this.setState({
        lastLockedDate: moment(maxDate.locked_datetime).format(
          'DD-MM-YYYY:HH:MM'
        ),
        todayDate: moment(date).format('DD-MM-YYYY:HH:MM'),
      })
    } else {
      this.setState({
        lastLockedDate: null,
        todayDate: moment(date).format('DD-MM-YYYY:HH:MM'),
      })
    }
  }

  checkIfTodayIsLockedVideo = async () => {
    const allWatchedVids = await this.props.folders.allWatchedVideos
    const date = moment().local().format('YYYY-MM-DD')

    if (allWatchedVids) {
      allWatchedVids.forEach((video) => {
        if (
          moment(video.locked_datetime).format('YYYY-MM-DD') == date &&
          video.album.title.includes('miazga') &&
          !video.is_intro
        ) {
          this.setState({
            isLockedVideoToday: true,
            todayLockedVideo: video,
          })
        }
      })
    }
  }

  isChosenVideohasBeenLocked = (videoId) => {
    let hasBeenWatched = false
    const watchedVideos = this.state.userWatchedVideosFromThisFolder
    if (watchedVideos) {
      watchedVideos.forEach((vid) => {
        if (vid.video_order_id == videoId && vid.is_watched) {
          hasBeenWatched = true
          return hasBeenWatched
        }
      })
    }
    return hasBeenWatched
  }

  getUserTrainingDays = async () => {
    let trainingDays

    if (this.context && !this.context.appState.trainingDays) {
      trainingDays = await trackPromise(getTrainingDays())

      this.context.updateAppState('trainingDays', trainingDays)
    } else {
      trainingDays = this.context.appState.trainingDays
    }

    this.setUserTrainingDays(trainingDays)

    const dateDay = new Date()

    let day = moment(dateDay).isoWeekday()

    this.setState({
      todayDay: day,
    })
  }

  setUserTrainingDays = (trainingDays) => {
    if (trainingDays) {
      this.setState({
        userTrainingDays: trainingDays.trainingDays,
      })
    }
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.state.isLoading,
    })
  }

  getApiVideoId = (uri) => {
    let lastDash = uri.lastIndexOf('/')
    let idString = uri.substring(lastDash + 1)

    return parseInt(idString)
  }

  openVideo = (videoPath, name, videoId) => {
    this.props.history.push({
      pathname: `/video/${slugify(name)}`,
      state: {
        path: videoPath,
        folder: this.state.folderName,
        folderApiPath: this.state.folderPath,
        videoId: videoId,
        albumId: this.state.albumId,
        videoApiId: this.getApiVideoId(this.state.videos[videoId].uri),
        lockedVideo: this.state.lockedVideo,
        watchedVideo: this.state.watchedVideo,
        hasBeenLocked: this.isChosenVideohasBeenLocked(videoId),
        isThisPaidContentFolder: this.state.isThisPaidContentFolder,
      },
    })
  }
  goback = () => {
    this.props.history()
  }

  splitFolderName = () => {
    let splittedName

    let { folderName } = this.props.location.state
    if (folderName.includes(';')) {
      splittedName = folderName.split(';')
      this.setState({
        folderName: `${splittedName[0]} - ${splittedName[1]}`,
      })
    } else {
      this.setState({
        folderName: folderName,
      })
    }
  }

  checkFolderEmail = () => {
    const { keywords } = this.state
    let email

    keywords.forEach((keyword) => {
      if (keyword.text.includes('EMAIL')) {
        email = keyword.text.split('_')[1]
      }
    })
    this.setState({
      folderContactEmail: email,
    })
  }

  checkIfIntroIsWatched = () => {
    const { folderName, userWatchedVideosFromThisFolder } = this.state

    if (
      userWatchedVideosFromThisFolder &&
      userWatchedVideosFromThisFolder.length != 0 &&
      folderName.toLowerCase().includes('miazga')
    ) {
      userWatchedVideosFromThisFolder.forEach((video) => {
        if (video.is_intro && video.is_watched) {
          this.setState({
            isMiazgaEntryVideoWatched: true,
          })
        }
      })
    }
  }

  shouldRenderDialog = () => {
    const { folderName, isMiazgaEntryVideoWatched } = this.state

    if (
      (folderName == 'MIAZGA 1 - MŁODSZAKI' ||
        folderName == 'MIAZGA 1 - MALUCHY' ||
        folderName == 'MIAZGA 1 - ŚREDNIAKI') &&
      !isMiazgaEntryVideoWatched
    ) {
      this.setState({
        shouldRenderDialog: true,
      })
    }
  }

  temporaryCloseDialog = () => {
    this.setState({
      shouldRenderDialog: false,
    })
  }

  toggleNotCompletedLockedTrainingPopupOpen = () => {
    this.setState({
      isNotCompletedLockedTrainingPopupOpen:
        !this.state.isNotCompletedLockedTrainingPopupOpen,
    })
  }

  // shouldShowTodayWatchedVideo = () => {
  //   let shouldShowPrevVid
  //   // IF today was watched completelly training and this training is not entry vid
  //   if()
  // }

  completedMiazgaTrainingName = () => {
    const watchedVideoOrder = this.state.lastWatchedVideoFromThisFolder
      ? this.state.lastWatchedVideoFromThisFolder.video_order_id
      : null

    const watchedVideoName = this.state.videos.filter(
      (video) => video.order == watchedVideoOrder
    )

    return watchedVideoName && watchedVideoName.length
      ? watchedVideoName[0].name
      : 0
  }

  render() {
    return (
      <MobileFolderScreen
        checkIfItsFirstVideo={this.checkIfItsFirstVideo}
        checkIfPrevVidIswatched={this.checkIfPrevVidIswatched}
        checkIfThisIsLockedVid={this.checkIfThisIsLockedVid}
        albumId={this.state.albumId}
        isLoading={this.state.isLoading}
        videos={this.state.videos}
        openVideo={this.openVideo}
        isLockedVideoToday={this.state.isLockedVideoToday}
        folderName={this.state.folderName}
        pdfUrls={this.state.pdfUrls}
        unlockAlgorithm={this.unlockAlgorithm}
        isWatchedAndLocked={this.isWatchedAndLocked}
        showUnlockTime={this.showUnlockTime}
        renderNextTrainingBadge={this.renderNextTrainingBadge}
        folderContactEmail={this.state.folderContactEmail}
        shouldRenderDialog={this.state.shouldRenderDialog}
        temporaryCloseDialog={this.temporaryCloseDialog}
        shouldPaidPackageVideoBeUnlocked={this.shouldPaidPackageVideoBeUnlocked}
        lastWatchedVideoFromThisFolder={
          this.state.lastWatchedVideoFromThisFolder
        }
        nextTrainingToWatchOrder={this.state.nextTrainingToWatchOrder}
        toggleAfterTrainingPopupOpen={this.toggleAfterTrainingPopupOpen}
        isAfterTrainingPopupOpen={this.state.isAfterTrainingPopupOpen}
        isAfterCompleteMiazgaPopupOpen={
          this.state.isAfterCompleteMiazgaPopupOpen
        }
        toggleAfterCompleteMiazgaPopupOpen={
          this.toggleAfterCompleteMiazgaPopupOpen
        }
        userCurrentStage={this.state.userCurrentStage}
        isTodayWatchedVideo={this.state.isTodayWatchedVideo}
        todayWatchedVideo={this.state.todayWatchedVideo}
        userWatchedVideosFromThisFolder={
          this.state.userWatchedVideosFromThisFolder
        }
        isNotCompletedLockedTrainingPopupOpen={
          this.state.isNotCompletedLockedTrainingPopupOpen
        }
        toggleNotCompletedLockedTrainingPopupOpen={
          this.toggleNotCompletedLockedTrainingPopupOpen
        }
        todayLockedVideo={this.state.todayLockedVideo}
        isThisPaidContentFolder={this.state.isThisPaidContentFolder}
        completedMiazgaTrainingName={this.completedMiazgaTrainingName}
        isTodayTrainingDay={this.state.isTodayTrainingDay}
      />
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    videosActions: bindActionCreators(videosActions, dispatch),
    folderActions: bindActionCreators(folderActions, dispatch),
  }
}

function mapStateToProps(state) {
  return {
    videos: state.videos.videos,
    user: state.user,
    folders: {
      allWatchedVideos: state.folders.userAllWatchedVideos,
      folderWatchedVideos: state.folders.userFolderWatchedVideos,
    },
    isLoading: state.videos.isLoading || state.isLoading,
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(MobileFolderScreenContainer)
